export const sharingEnglish = {
  retry: 'Try again',
  title: 'Share board',
  company: 'Company',
  allCompanies: 'All companies',
  chooseCompany: 'Choose a company',
  anonymous: 'Anonymous',
  unavailable: 'This link is unavailable or you do not have access.',
  restricted: 'Restricted',
  public: 'Public',
  restrictedHelp:
    'Only the selected Sparck accounts with these email addresses can open this link. Each recipient receives an invitation.',
  existingLinks: 'Existing links',
  linkAccess: 'Link and access',
  linkRecipients: 'Recipients',
  linkExpiry: 'Expiration and replacement',
  noRecipients: 'No recipients added.',
  restrictedRecipientsHelp:
    'Access is limited to these Sparck accounts with matching email addresses.',
  recipientCount:
    '{count, plural, =0 {No recipients} one {# recipient} other {# recipients}}',
  recipients: 'Recipient emails',
  recipientsHelp:
    'Up to 100 addresses, separated with commas or new lines. Restricted links require at least one existing account.',
  expiry: 'Expires at',
  replacementExpiry: 'New expiry',
  create: 'Create link',
  close: 'Close',
  copy: 'Copy link',
  copied: 'Link copied.',
  open: 'Open link',
  add: 'Add recipients',
  remove: 'Remove',
  resend: 'Send invitation',
  reissue: 'Replace link',
  revoke: 'Revoke',
  reissueConfirm:
    'Replace this URL and send new invitations? The old link will stop working.',
  revokeConfirm: 'Revoke this link for everyone?',
  rotateHelp:
    'Replacing the link keeps its audience and sends new invitations.',
  active: 'Active',
  expired: 'Expired',
  revoked: 'Revoked',
  pending: 'Queued',
  sending: 'Sending',
  sent: 'Sent',
  failed: 'Failed — retry available',
  skipped: 'Cancelled',
  unpublished: 'Publish this board before creating a share link.',
  empty: 'No share links yet.',
  error: 'Unable to complete this action. Please try again.',
  sentHelp:
    'Email invitations are queued individually. Delivery status appears below.',
  createdBy: 'Created by {name}',
  themeLabel: 'Theme',
  themeAuto: 'Auto',
  themeLight: 'Light',
  themeDark: 'Dark',
}
export const sharingPortuguese: typeof sharingEnglish = {
  retry: 'Tentar novamente',
  title: 'Compartilhar board',
  company: 'Empresa',
  allCompanies: 'Todas as empresas',
  chooseCompany: 'Escolha uma empresa',
  anonymous: 'Anônimo',
  unavailable: 'Este link está indisponível ou você não tem acesso.',
  restricted: 'Restrito',
  public: 'Público',
  restrictedHelp:
    'Somente as contas Sparck selecionadas com estes e-mails podem abrir o link. Cada destinatário recebe um convite.',
  existingLinks: 'Links existentes',
  linkAccess: 'Link e acesso',
  linkRecipients: 'Destinatários',
  linkExpiry: 'Validade e substituição',
  noRecipients: 'Nenhum destinatário adicionado.',
  restrictedRecipientsHelp:
    'O acesso é limitado a estas contas Sparck com os e-mails correspondentes.',
  recipientCount:
    '{count, plural, =0 {Sem destinatários} one {# destinatário} other {# destinatários}}',
  recipients: 'E-mails dos destinatários',
  recipientsHelp:
    'Até 100 endereços, separados por vírgulas ou linhas. Links restritos exigem pelo menos uma conta existente.',
  expiry: 'Expira em',
  replacementExpiry: 'Nova expiração',
  create: 'Criar link',
  close: 'Fechar',
  copy: 'Copiar link',
  copied: 'Link copiado.',
  open: 'Abrir link',
  add: 'Adicionar destinatários',
  remove: 'Remover',
  resend: 'Enviar convite',
  reissue: 'Substituir link',
  revoke: 'Revogar',
  reissueConfirm:
    'Substituir a URL e enviar novos convites? O link antigo deixará de funcionar.',
  revokeConfirm: 'Revogar o link para todos?',
  rotateHelp:
    'Substituir o link mantém o acesso definido e envia novos convites.',
  active: 'Ativo',
  expired: 'Expirado',
  revoked: 'Revogado',
  pending: 'Na fila',
  sending: 'Enviando',
  sent: 'Enviado',
  failed: 'Falhou — pode reenviar',
  skipped: 'Cancelado',
  unpublished: 'Publique o board antes de criar um link.',
  empty: 'Nenhum link de compartilhamento.',
  error: 'Não foi possível concluir. Tente novamente.',
  sentHelp:
    'Os convites são enviados individualmente. Acompanhe o status abaixo.',
  createdBy: 'Criado por {name}',
  themeLabel: 'Tema',
  themeAuto: 'Automático',
  themeLight: 'Claro',
  themeDark: 'Escuro',
}
